import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import {Button, CircularProgress} from "@nextui-org/react";
import ReactSkinview3d from "react-skinview3d";
import {CardComponent} from "../Components/card.component";
import {useWindowSize} from "@uidotdev/usehooks";
import {ChevronLeft, Download, Favorite, Share} from "@mui/icons-material";
import {useMediaQuery} from "@mui/material";
import {delay} from "framer-motion";
import {saveAs} from 'file-saver';

const DetailScreen = () => {

    const [skins, setSkins] = useState(null);
    const [loader, setLoader] = useState(false);

    const downloadImage = (url, id) => {
        saveAs(url, id) // Put your image URL here.
    }
    const config = {
        mode: 'no-cors',
        headers: {Authorization: `Bearer e8501a2c3c56b6c611930609b53c0e083fdfe24466bf536d86629c2aaa655f555cce662bc4e8ba94e5bc9c164b056e36507f8b042869d59da13ae35a10a0bc73`}
    };
    const {skinId} = useParams();
    const size = useWindowSize();
    const [localLikes, setLocalLikes] = useState([]);
    const [fav, setFav] = useState(false);


    function checkIfExistInFav(argItem) {
        let i = argItem.find(function (person) {
            return person.skin_id === skinId.split("|")[0];
        });
        return i !== undefined;
    }

    function fetchLocalLikes() {
        const items = JSON.parse(localStorage.getItem('local_likes'));
        if (items) {
            setLocalLikes(items);
            setFav(checkIfExistInFav(items))
        }
    }

    async function fetchDetails() {
        setLoader(true);
        let url = `https://dataapi.miracocopepsi.com/public/api/minecraft/skin/${skinId.split("|")[0]}`;
        let temp = await axios.get(url, config);
        setSkins(temp);
        setLoader(false);
    }


    function setLocalLikeToStorage() {
        localStorage.setItem('local_likes', JSON.stringify(localLikes));
        setFav(checkIfExistInFav(localLikes))
    }

    const navigate = useNavigate();

    const isSmallDevice = useMediaQuery("only screen and (max-width : 768px)");

    useEffect(() => {
        fetchDetails().then(r => {
            fetchLocalLikes();
        });
    }, [skinId]);

    Array.prototype.remove = function () {
        var what, a = arguments, L = a.length, ax;
        while (L && this.length) {
            what = a[--L];
            while ((ax = this.indexOf(what)) !== -1) {
                this.splice(ax, 1);
            }
        }
        return this;
    };

    return (
        skins == null || loader.data ? <div className={'h-screen w-screen flex justify-center mx-auto'}>
            <CircularProgress aria-label="Loading..."/>
        </div> : <div className={'flex justify-center'}>
            <div className={' mx-auto px-4'}>
                <div className={'flex justify-between w-full'}>
                    <Button variant={'ghost'} startContent={<ChevronLeft/>} onClick={() => {
                        navigate(-1);
                    }}>
                        Back
                    </Button>
                    {isSmallDevice ? <div>

                        <Button onClick={() => {
                            let isLikes = checkIfExistInFav(localLikes);
                            if (isLikes) {
                                let index = localLikes.findIndex(value => value.id === skins.data.data.id);
                                console.log(index);
                                localLikes.splice(index, 1);
                            } else {
                                let isCape = skinId.split("|")[1] === "true";
                                let d = skins.data.data;
                                if (isCape) {
                                    d['isCape'] = true;
                                } else {
                                    d['isCape'] = false;
                                }
                                localLikes.push(d);
                            }
                            setLocalLikeToStorage();
                            delay(overshoot => setLoader(false), 1000);
                            console.log(localLikes);
                        }} color={fav ? 'danger' : 'default'} variant={fav ? 'solid' : 'ghost'} isIconOnly={true}
                                className={'mx-2'} startContent={<Favorite/>}/>


                        <Button isIconOnly={true} className={'mx-2'} startContent={<Share/>} onClick={ async () => {
                            let data = {
                                title: "Claim your Free Skin",
                                text: "Look i found a great minecraft skin for you claim now",
                                url: window.location.href,
                            };
                            try {
                                await window.navigator.share(data);
                            } catch (e) {
                                if (e.toString().includes('AbortError')) {
                                    alert('Share aborted :(');
                                }
                            }
                        }}/>
                        <Button onClick={() => {
                            downloadImage("http://dataapi.miracocopepsi.com/public/api/image/" + skins.data.data.skin_id + ".png", skins.data.data.skin_id + ".png");
                        }} isIconOnly={true} className={'mx-2'} startContent={<Download/>}/>

                    </div> : <div>

                        <Button color={fav ? 'danger' : 'default'} variant={fav ? 'solid' : 'ghost'}
                                className={'mx-2'}
                                startContent={<Favorite/>}
                                onClick={() => {
                                    let isLikes = checkIfExistInFav(localLikes);
                                    if (isLikes) {
                                        let index = localLikes.findIndex(value => value.id === skins.data.data.id);
                                        console.log(index);
                                        localLikes.splice(index, 1);
                                    } else {
                                        let isCape = skinId.split("|")[1] === "true";
                                        let d = skins.data.data;
                                        if (isCape) {
                                            d['isCape'] = true;
                                        } else {
                                            d['isCape'] = false;
                                        }
                                        localLikes.push(d);
                                    }
                                    setLocalLikeToStorage();
                                    delay(overshoot => setLoader(false), 1000);
                                    console.log(localLikes);
                                }}>
                            Favourite
                        </Button>

                        <Button className={'mx-2'} startContent={<Share/>} onClick={ async () => {
                            let data = {
                                title: "Claim your Free Skin",
                                text: "Look i found a great minecraft skin for you claim now",
                                url: window.location.href,
                            };
                            try {
                                await window.navigator.share(data);
                            } catch (e) {
                                if (e.toString().includes('AbortError')) {
                                    alert('Share aborted :(');
                                }
                            }
                        }}>
                            Share
                        </Button>
                        <Button onClick={() => {
                            downloadImage("http://dataapi.miracocopepsi.com/public/api/image/" + skins.data.data.skin_id + ".png", skins.data.data.skin_id + ".png");
                        }} className={'mx-2'} startContent={<Download/>}>
                            Download
                        </Button>
                    </div>}
                </div>
                <h1 className={'py-10 text-2xl text-center'}>{skins.data.data.title}</h1>
                <div className={'flex justify-center'}>
                    <ReactSkinview3d

                        // skinUrl={require('../assets/img.png')}
                        skinUrl={skinId.split("|")[1] === "true" ? require('../assets/img.png') : "http://dataapi.miracocopepsi.com/public/api/image/" + skins.data.data.skin_id + ".png"}
                        capeUrl={skinId.split("|")[1] === "true" ? ("http://dataapi.miracocopepsi.com/public/api/image/" + skins.data.data.skin_id + ".png") : ''}
                        height={size.height / 3} width={size.width / 3}/>
                </div>
                <div className={'px-5 sm:px-20 py-5'}>
                    <h1 className={'text-xl sm:text-3xl font-bold w-full'}> Similar Skins</h1>
                </div>
                <div
                    className="px-5 pb-10 w-full gap-3 grid xl:grid-cols-6 lg:grid-cols-8 md:grid-cols-4 sm:grid-cols-3 grid-cols-2 sm:px-20 sm:pt-5">
                    {
                        skins.data.suggestions.map((item, index) => {
                            return <div key={`Suggestion_Card_${index}`}>
                                <CardComponent props={
                                    {
                                        "item": item,
                                        "index": index
                                    }
                                }/>
                            </div>
                        })
                    }
                </div>

            </div>
        </div>
    );
};

export default DetailScreen;